<template>
  <div class="container" v-if="!isCorrect">
    <h1>Es-tu capable de trier ca du plus ancien au plus récent ?</h1>
    <draggable v-model="songs" class="song-list" @end="onDragEnd">
      <div v-for="song in songs" :key="song.id" class="song-item">
        <div class="song-number">{{ song.name }}</div>
        <button @click="togglePlay(song)" class="play-button">
          {{ song.isPlaying ? "⏸️" : "▶️" }}
        </button>
        <div class="song-number">{{ song.name }}</div>
      </div>
    </draggable>
    <button @click="validateOrder" class="validate-button">VALIDER</button>
    <p v-if="message" class="message">{{ message }}</p>
  </div>
  <div v-else class="victory-message">
    <h2>BRAVO !</h2>
    <p>
      Apparemment t'as une bonne mémoire, alors retiens bien ca : Caro et Ben t'invitent avec Alice à faire l'escape game de ton choix !!
      <br/>
      <br/>
      Joyeux GOSTANNIVERSAIRE !!!
    </p>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "MusicSorter",
  components: {
    draggable,
  },
  data() {
    return {
      songs: [
        { id: 1, name: "1", file: "Big Jet Plane 2019.mp3", isPlaying: false },
        { id: 2, name: "2", file: "Days Run Out 2016.mp3", isPlaying: false },
        { id: 3, name: "3", file: "Never Said 2017.mp3", isPlaying: false },
        { id: 4, name: "4", file: "Disappear 2024.mp3", isPlaying: false },
        { id: 5, name: "5", file: "Take me 2015.mp3", isPlaying: false },
        { id: 6, name: "6", file: "Nouvel An 2025.wav", isPlaying: false },
        { id: 7, name: "7", file: "World is One 2020.mp3", isPlaying: false },
      ],
      correctOrder: [5, 2, 3, 1, 7, 4, 6], // ID des morceaux dans le bon ordre
      message: "",
      isCorrect: false,
      audio: null,
      currentPlayingId: null,
    };
  },
  methods: {
    togglePlay(song) {
      if (this.currentPlayingId === song.id) {
        // Pause si c'est la même chanson
        this.pauseSong(song);
      } else {
        // Nouvelle chanson, stop tout et play
        this.stopAllSongs();
        this.startSong(song);
      }
    },
    startSong(song) {
      this.audio = new Audio(require(`@/assets/${song.file}`));
      this.audio.play();
      this.audio.onended = () => this.stopAllSongs(); // Quand la chanson finit

      this.currentPlayingId = song.id;
      song.isPlaying = true;
    },
    pauseSong(song) {
      if (this.audio) {
        this.audio.pause();
        song.isPlaying = false;
        this.currentPlayingId = null;
      }
    },
    stopAllSongs() {
      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.audio = null;
      }
      this.songs.forEach((s) => (s.isPlaying = false));
      this.currentPlayingId = null;
    },
    validateOrder() {
      this.isCorrect = this.songs.every(
        (song, index) => song.id === this.correctOrder[index]
      );
      if (this.isCorrect) {
        this.message = "BRAVO !";
        this.stopAllSongs();
      } else {
        this.message = "Ce n'est pas le bon ordre !";
      }
    },
    onDragEnd() {
      this.message = ""; // Réinitialiser le message après chaque drag
    },
  },
  beforeDestroy() {
    this.stopAllSongs(); // Nettoyer l'audio si on quitte le composant
  },
};
</script>

<style scoped>
.container {
  text-align: center;
  margin: 20px;
}
.song-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
}
.song-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #eee;
  border-radius: 8px;
  cursor: grab;
}
.song-number {
  font-weight: bold;
}
.play-button {
  margin-right: 10px;
}
.validate-button {
  margin-top: 20px;
  padding: 10px 20px;
  width: 80%;
}
.message {
  margin-top: 15px;
  font-size: 1.2em;
  color: red;
  background: white;
  padding: 10px 0;
}
.victory-message {
  text-align: center;
  font-size: 2em;
  color: white;
  margin: 20px;
  background: green;
  padding: 5px;
}
</style>
